import { Modal } from "react-bootstrap";
import { useEffect, useState } from "react";
import "../styles/CouponsModel.css";

interface CouponModalProps {
  show: boolean;
  onClose: () => void;
  onApply: (code: string) => void;
  couponList: [];
}

const CouponModal = ({ show, onClose, onApply, couponList }: CouponModalProps) => {
  const [manualCode, setManualCode] = useState("");

  useEffect(() => {
    if (show) setManualCode("");
  }, [show]);


  return (
    <Modal show={show} onHide={onClose} centered className="coupon-modal">
      <Modal.Header closeButton>
        <Modal.Title>Apply Coupon</Modal.Title>
      </Modal.Header>

      <Modal.Body className="coupon-body">
        {/* Manual input */}
        <div className="coupon-input-row">
          <input
            type="text"
            value={manualCode}
            onChange={(e) => setManualCode(e.target.value.toUpperCase())}
            placeholder="Enter coupon code"
            className="coupon-input"
          />
          <button
            className="coupon-input-apply"
            disabled={!manualCode}
            onClick={() => onApply(manualCode)}
          >
            APPLY
          </button>
        </div>

        <div className="coupon-divider">Available Coupons</div>

        {/* Coupon list */}
        <div className="coupon-list">
          {couponList?.length > 0 ? (
            couponList.map((coupon: any) => (
              <div key={coupon?.id} className="coupon-item">
                <div className="coupon-accent" />
                <div className="coupon-content">
                  <div className="coupon-header">
                    <div className="coupon-text">
                      <div className="coupon-short">{coupon.description}</div>
                      <div className="coupon-long">{coupon.long_description}</div>
                      <div className="coupon-code">{coupon.name}</div>
                    </div>
                    <button
                      className="coupon-apply"
                      onClick={() => onApply(coupon.name)}
                    >
                      APPLY
                    </button>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="coupon-empty">
              <div className="coupon-empty-icon">🏷️</div>
              <div className="coupon-empty-title">No coupons available</div>
              <div className="coupon-empty-subtitle">
                Enter a code above to apply a coupon manually
              </div>
            </div>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default CouponModal;